import viewTypes from 'helpers/enums/viewTypes'

const viewsTocreationRouteTypes = {
	[viewTypes.TIME_TO_CLIMB_CREATION]: 'game',
	[viewTypes.TIME_TO_CLIMB_STANDALONE_CREATION]: 'standalone/game',
	[viewTypes.DRAW_IT_CREATION]: 'draw-it',
	[viewTypes.DRAW_IT_STANDALONE_CREATION]: 'standalone/draw_it',
	[viewTypes.MATCHING_PAIRS_CREATION]: 'matching-pairs',
	[viewTypes.MATCHING_PAIRS_STANDALONE_CREATION]: 'standalone/matching-pairs',
}

export default view => viewsTocreationRouteTypes[view] || ''
